export default __webpack_public_path__ + "static/media/file_upload.641c22a3.png";